import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE, DEFAULT_NS } from "../../translations/config";

import commonEn from "../../translations/en/common.json";
import landingEn from "../../translations/en/landing.json";
import dashboardEn from "../../translations/en/dashboard.json";
import authEn from "../../translations/en/auth.json";
import seoEn from "../../translations/en/seo.json";
import appEn from "../../translations/en/app.json";
import guidesEn from "../../translations/en/guides.json";

import commonIt from "../../translations/it/common.json";
import landingIt from "../../translations/it/landing.json";
import dashboardIt from "../../translations/it/dashboard.json";
import authIt from "../../translations/it/auth.json";
import seoIt from "../../translations/it/seo.json";
import appIt from "../../translations/it/app.json";
import guidesIt from "../../translations/it/guides.json";

import commonDe from "../../translations/de/common.json";
import landingDe from "../../translations/de/landing.json";
import dashboardDe from "../../translations/de/dashboard.json";
import authDe from "../../translations/de/auth.json";
import seoDe from "../../translations/de/seo.json";
import appDe from "../../translations/de/app.json";
import guidesDe from "../../translations/de/guides.json";

import commonFr from "../../translations/fr/common.json";
import landingFr from "../../translations/fr/landing.json";
import dashboardFr from "../../translations/fr/dashboard.json";
import authFr from "../../translations/fr/auth.json";
import seoFr from "../../translations/fr/seo.json";
import appFr from "../../translations/fr/app.json";
import guidesFr from "../../translations/fr/guides.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: commonEn,
      landing: landingEn,
      dashboard: dashboardEn,
      auth: authEn,
      seo: seoEn,
      app: appEn,
      guides: guidesEn,
    },
    fr: {
      common: commonFr,
      landing: landingFr,
      dashboard: dashboardFr,
      auth: authFr,
      seo: seoFr,
      app: appFr,
      guides: guidesFr,
    },
    de: {
      common: commonDe,
      landing: landingDe,
      dashboard: dashboardDe,
      auth: authDe,
      seo: seoDe,
      app: appDe,
      guides: guidesDe,
    },
    it: {
      common: commonIt,
      landing: landingIt,
      dashboard: dashboardIt,
      auth: authIt,
      seo: seoIt,
      app: appIt,
      guides: guidesIt,
    },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: "en",
  defaultNS: DEFAULT_NS,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
